import { render, staticRenderFns } from "./register_completed.vue?vue&type=template&id=1b61610c"
import script from "./register_completed.vue?vue&type=script&lang=js"
export * from "./register_completed.vue?vue&type=script&lang=js"
import style0 from "./register_completed.vue?vue&type=style&index=0&id=1b61610c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports